import { Strings } from "src/modules/utils/shared/strings";
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Type } from 'class-transformer';
import { SmBaseEntity } from 'src/modules/sm-base/shared/sm-base-entity.model';
import { Column, Entity } from 'typeorm';
import { DatabaseUserAttribute } from './database-user-attribute.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { DatabaseUserGroup } from './database-user-group.model';
import { Arrays } from 'src/modules/utils/shared/arrays';

@Entity()
export class DatabaseUser extends SmBaseEntity {
    @Column({default: "", unique: true})
    userName: string = "";

    @Column({default: ""})
    passwordHash: string = "";

    @Column({default: ""})
    firstName: string = "";

    @Column({default: ""})
    lastName: string = "";

    @Column({ default: "", length: 10_000 })
    mail: string = "";

    @Column({default: "", length: 1})
    gender: string = "";

    @Column({default: true})
    active: boolean = true;

    @Column({default: false})
    mustChangePassword: boolean = false;

    @Column({default: ""})
    passwordResetHash: string = "";

    @Column({default: ""})
    phone: string = "";

    @Column({default: false})
    activated: boolean = false;

    @Column({default: "" })
    activationCode: string = "";

    @Column({nullable: true})
    @Type(() => Date)
    activationExpires: Date = null;

    @Column({nullable: false, default: true})
    sendNotificationMails: boolean = true;

    @Column({default: false})
    isAdmin: boolean = false;

    @Column("text", { array: true, nullable: true })
    recoveryQuestions: string[] = [];

    @Column("text", { array: true, nullable: true })
    recoveryAnswers: string[] = [];

    @Column({default: false})
    privacyPolicyAccepted: boolean = false;

    @Column({default: ""})
    source: string = "";

    @Column({default: 0})
    color: number = 0;

    @Column({default: 0})
    calendarId: number = 0;

    @Type(() => DatabaseUserAttribute)
    attributes: DatabaseUserAttribute[] = [];

    @Type(() => DatabaseUserGroup)
    groups: DatabaseUserGroup[] = [];

    getStringRepresentation(): string {
        return Strings.def(this.getFullName(), this.userName);
    }

    getFullName(appendUserName = false): string {
        return Utils.isNoe(this.lastName) && Utils.isNoe(this.firstName) ? this.userName : Strings.def(this.lastName) + ", " + Strings.def(this.firstName).trim() + (appendUserName ? " (" + this.userName + ")" : "");
    }

    resetToInitial(passwordHash: string): void {
        this.passwordHash = passwordHash;
        this.mustChangePassword = true;
        this.recoveryQuestions = [];
        this.recoveryAnswers = [];
    }

    getAttributeValue(name: string): string {
        let attrib = this.attributes.find(a => a.key == name);
        if (attrib == null) {
            throw new Error("Das Benutzer-Attribut '" + name + "' wurde nicht gefunden. Verfügbare Attribute: " + Arrays.itemsToString(this.attributes, ", ", a => a.key));
        }
        return attrib.value;
    }

    getAttributeValueSafe(name: string, def: string = null): string {
        let attrib = this.attributes.find(a => a.key == name);
        return attrib != null ? attrib.value : def;
    }

    getAttributeValueBool(name: string): boolean {
        return Utils.toBool(this.getAttributeValue(name));
    }

    getAttributeValueNumber(name: string): number {
        return Utils.toNumber(this.getAttributeValue(name));
    }
}